import type { TodoItemData } from '@/types/tools';
import { PERCENTAGE_MULTIPLIER } from '@/constants/ui.constants';

/**
 * Sort todos by status: in_progress first, then pending, then completed
 */
export function sortTodosByStatus(
  todos: TodoItemData[]
): TodoItemData[] {
  const order = { in_progress: 0, pending: 1, completed: 2 };
  return [...todos].sort((a, b) => {
    const orderA = order[a.status] ?? 2;
    const orderB = order[b.status] ?? 2;
    return orderA - orderB;
  });
}

/**
 * Calculate progress percentage from completed and total counts
 */
export function calculateProgressPercentage(
  completedCount: number,
  totalCount: number
): number {
  if (totalCount === 0) {
    return 0;
  }
  return (completedCount / totalCount) * PERCENTAGE_MULTIPLIER;
}

